import { Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { VIEW_PAYLOAD_LABEL } from "../../constants";
import classes from "./UserLogs.module.scss";

const { Link } = Typography;

export const getUserLogsColumns = ({ onViewPayload }) => [
  { title: "Tipo evento", dataIndex: "eventType", key: "eventType" },
  { title: "Evento", dataIndex: "event", key: "event" },
  { title: "Data", dataIndex: "date", key: "date" },
  {
    title: "Payload",
    key: "payload",
    render: (_, record) => (
      <Link
        className={classes.ViewPayloadLink}
        onClick={() => onViewPayload(record)}
      >
        {VIEW_PAYLOAD_LABEL} <SearchOutlined className={classes.ViewIcon} />
      </Link>
    ),
  },
];
